type OutputLanguageOption = {
  labelKey: string
  value: ProjectModels.UseLanguage
}

const I18N_OUTPUT_LANGUAGE_MAP: Partial<Record<string, ProjectModels.UseLanguage>> = {
  zh: 'CN',
  en: 'EN',
  ja: 'JP',
  ko: 'KR',
  fr: 'FR',
  'zh-Hant': 'TW',
}

export const CREATIVE_DIAGNOSIS_OUTPUT_LANGUAGE_OPTIONS: OutputLanguageOption[] = [
  { labelKey: 'dashboard.projectCreatePage.languageSelect.chinese', value: 'CN' },
  { labelKey: 'dashboard.projectCreatePage.languageSelect.english', value: 'EN' },
  { labelKey: 'dashboard.projectCreatePage.languageSelect.japanese', value: 'JP' },
  { labelKey: 'dashboard.projectCreatePage.languageSelect.korean', value: 'KR' },
  { labelKey: 'dashboard.projectCreatePage.languageSelect.french', value: 'FR' },
  { labelKey: 'dashboard.projectCreatePage.languageSelect.traditionalChinese', value: 'TW' },
]

export const SURVEY_OUTPUT_LANGUAGE_OPTIONS: OutputLanguageOption[] = [
  { labelKey: 'dashboard.projectCreatePage.languageSelect.chinese', value: 'CN' },
  { labelKey: 'dashboard.projectCreatePage.languageSelect.traditionalChinese', value: 'TW' },
  { labelKey: 'dashboard.projectCreatePage.languageSelect.english', value: 'EN' },
  { labelKey: 'dashboard.projectCreatePage.languageSelect.japanese', value: 'JP' },
  { labelKey: 'dashboard.projectCreatePage.languageSelect.korean', value: 'KR' },
  { labelKey: 'dashboard.projectCreatePage.languageSelect.french', value: 'FR' },
]

export const PPT_TRANSLATE_LANGUAGE_OPTIONS = SURVEY_OUTPUT_LANGUAGE_OPTIONS

export function resolveOutputLanguageByI18nLanguage(
  language: string,
  fallbackLanguage: ProjectModels.UseLanguage
) {
  return I18N_OUTPUT_LANGUAGE_MAP[language] || fallbackLanguage
}
